package de.oevbs.kunde.kundenportal2.authentication.components

import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kunde.kundenportal2.Pages

import de.oevbs.kunde.kundenportal2.navigation.visit
import dev.fritz2.core.RenderContext

fun RenderContext.loginButton() {
    btn {
        label("Login")
    }.clicks handledBy {
        // Dadurch, dass beim Besuch jeder Seite das Login-Formular vorgeschaltet wird, wenn der Nutzer nicht
        // angemeldet ist, muss hier nichts weiter getan werden, als zur Hauptseite zu navigieren.
        Pages.root.visit()
    }
}